import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {NotificationsService} from '@catcore/services';
import {GenericResourceService} from '@catfeatures/services/generic-resource.service';
import {ParametersService} from '@catmodels/parameters/services/parameters.service';
import {Parameter} from '@catmodels/parameters/types';
import {ActiveModal} from '@catmodules/widgets/slide-in-modal/utils/modal-ref';
import {StyleType} from '@catui/types';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'catapp-modify-parameter',
  templateUrl: './modify-parameter.component.html',
  styleUrls: ['./modify-parameter.component.scss'],
})
export class ModifyParameterComponent implements OnInit {

  private _parameter: Parameter;

  form: FormGroup;
  styleType = StyleType;

  @Input() featureLevel = false;
  @Input() feature = null;
  @Input() fileList: any[];
  @Input() enableDelete: boolean = false;

  @Output() afterDelete = new EventEmitter();
  @Output() afterUpdate = new EventEmitter<Parameter>();

  set parameter(value: Parameter) {
    this._parameter = value;
    if (!isNullOrUndefined(this._parameter)) {
      this.form.patchValue({key: this._parameter.key});
      this.form.patchValue({value: this._parameter.value});
    }
  }

  get parameter(): Parameter {
    return this._parameter;
  }

  get dataIsReady() {
    return !isNullOrUndefined(this._parameter);
  }

  constructor(private formBuilder: FormBuilder,
              private genericResourceService: GenericResourceService,
              private activeModal: ActiveModal,
              private notification: NotificationsService,
              private parametersService: ParametersService) {
    this.form = this.formBuilder.group({
      key: ['', []],
      value: ['', []],
    });
  }

  ngOnInit() {
  }

  saveParameter(event) {
    if (this._parameter) {
      const newParamValue = this.form.value.value;
      this.parametersService.save(this._parameter, newParamValue)
        .subscribe((updatedParam) => {
          this.notification.success('Update successful', 'Successfully updated  parameter ' + this._parameter.key);
          this.afterUpdate.emit(updatedParam);
          this.activeModal.close();
        });
    }
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/parameters/components/modify-parameter/modify-parameter.component.ts